module.exports = __webpack_public_path__ + "media/patterns/stars-1-6014f488.svg";